import { Pattern } from '../types/pattern';
import { preloadImages } from '../stitches/svg-renderer';
import { drawStitchLegend, measureStitchLegendHeight } from '../components/PatternCanvas/StitchLegend';

interface ExportImageOptions {
  canvas: HTMLCanvasElement;
  pattern: Pattern;
  format: 'png' | 'jpg';
  translations: {
    stitchTypes: { [key: string]: string | undefined };
    legend: { signature: string };
  };
  language: string;
}

export async function exportImage({ canvas, pattern, format, translations, language }: ExportImageOptions) {
  // Pre-load SVG images for legend stitch color
  const usedTypes = Array.from(new Set(pattern.stitches.map(s => s.type)));
  await preloadImages(usedTypes, '#382f2d');

  const link = document.createElement('a');
  const mimeType = format === 'png' ? 'image/png' : 'image/jpeg';
  const extension = format === 'png' ? 'png' : 'jpg';
  const safeName = pattern.name.replace(/[^a-zA-Z0-9_\-\s]/g, '').trim() || 'pattern';
  link.download = `${safeName}.${extension}`;

  const tempCanvas = document.createElement('canvas');
  const patternWidth = canvas.width;
  const patternHeight = canvas.height;
  tempCanvas.width = patternWidth;
  const tempCtx = tempCanvas.getContext('2d');

  if (tempCtx) {
    const legendHeight = measureStitchLegendHeight(pattern);
    tempCanvas.height = patternHeight + legendHeight;

    if (format === 'jpg') {
      tempCtx.fillStyle = 'white';
      tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
    }

    tempCtx.drawImage(canvas, 0, 0);
    drawStitchLegend({ pattern, ctx: tempCtx, startY: patternHeight, canvasWidth: patternWidth, translations, language });

    link.href = tempCanvas.toDataURL(mimeType);
    link.click();
  }
}
